import { Banner, Change, ChangeTypes } from './admin-banners.type';

const toIdsMap = (banners: Banner[]) =>
    banners.reduce((acc, item) => {
        acc.set(item.id, item);
        return acc;
    }, new Map<string, Banner>());

const equal = (banner1: Banner, banner2: Banner) => {
    const [keys1, keys2] = [banner1, banner2].map(Object.keys);

    if (keys1.length !== keys2.length) return false;

    return keys1.every((key) => banner1[key] === banner2[key]);
};

export const getChanges = (initial: Banner[], displayed: Banner[], inactive: Banner[]) => {
    const initialMap = toIdsMap(initial);
    const currentMap = toIdsMap([
        ...displayed.map((banner, index) => ({
            ...banner,
            order: index,
            displayed: true,
        })),
        ...inactive.map(({ order, ...banner }) => ({
            ...banner,
            displayed: false,
        })),
    ]);

    const ids = [...initialMap.keys(), ...currentMap.keys()];
    const uniqIds = [...new Set(ids)];

    const changes: Change[] = [];

    for (let id of uniqIds) {
        const current = currentMap.get(id);
        const initial = initialMap.get(id);

        if (current && !initial) {
            changes.push({ type: ChangeTypes.CREATE, banner: current });
            continue;
        }
        if (initial && !current) {
            changes.push({ type: ChangeTypes.DELETE, banner: initial });
            continue;
        }
        if (!equal(initial, current)) {
            changes.push({ type: ChangeTypes.UPDATE, banner: current });
        }
    }

    return changes;
};

export const getIconById = (id: string) =>
    `/admin/rest-v2/cs/cms/ru/content/content/icon/${id}`;
